import { render, staticRenderFns } from "./MenuConfig.vue?vue&type=template&id=27d3b0a3&scoped=true"
import script from "./MenuConfig.vue?vue&type=script&lang=ts"
export * from "./MenuConfig.vue?vue&type=script&lang=ts"
import style0 from "./MenuConfig.vue?vue&type=style&index=0&id=27d3b0a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d3b0a3",
  null
  
)

export default component.exports